// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__NsfmF","info":"UpdateTermsInfo_info__1KpCe"};